import { addDays, format, isAfter, isBefore } from 'date-fns'

export const generateClassSchedule = () => {
  try {
    const startDate = new Date(2025, 8, 2) // September 2, 2025
    const classDays = [2, 3, 4] // Tuesday, Wednesday, Thursday (0=Sunday)
    const classes = []
    
    let currentDate = new Date(startDate)
    let classNumber = 1
    
    while (classNumber <= 285) {
      const dayOfWeek = currentDate.getDay()
      
      if (classDays.includes(dayOfWeek)) {
        classes.push({
          classNumber,
          date: new Date(currentDate),
          formattedDate: format(currentDate, 'MMMM d, yyyy'),
          dayName: format(currentDate, 'EEEE'),
          isPast: isBefore(currentDate, new Date()),
          isFuture: isAfter(currentDate, new Date())
        })
        classNumber++
      }
      
      currentDate = addDays(currentDate, 1)
    }
    
    return classes
  } catch (error) {
    console.error('Error generating class schedule:', error)
    return []
  }
}

export const getClassByNumber = (classNumber) => {
  try {
    const schedule = generateClassSchedule()
    return schedule.find(cls => cls.classNumber === classNumber) || null
  } catch (error) {
    console.error('Error getting class by number:', error)
    return null
  }
}